import {
    ChangeDetectionStrategy,
    Component, effect,
    ElementRef,
    inject,
    input,
    viewChild,
    ViewEncapsulation
} from '@angular/core';
import { AppSbAssetImage } from '../../types/types';
import { NavigationComponent } from '../navigation/navigation.component';
import { MatIconModule } from '@angular/material/icon';
import { LayoutService } from '../../../service/layout.service';
import { NavScrollDirective } from '../../directives/nav-scroll.directive';
import { ScrollToTableComponent } from '../../reusable/scroll-to-table/scroll-to-table.component';
import { ISbComponentType } from 'storyblok-js-client';
import { AppNavGroup } from '../navigation/nav-group';
import { ISbAsset } from '@seven1/model';
import { CmsComponent } from '@seven1/angular-storyblok-cms';
import { NgStyle } from '@angular/common';

export type LayoutStory = {
    header?: ISbComponentType<string>[];
    nav_children?: AppNavGroup[];
    nav_logo?: AppSbAssetImage[];
    footer?: ISbComponentType<string>[];
    lightMode: boolean;
} & ISbComponentType<string>;

export interface IAppLayoutConfig extends ISbComponentType<'layout'> {
    header: ISbComponentType<'image'>[];
    footer: ISbComponentType<string>[];
    nav_logo: AppSbAssetImage[];
    nav_children: AppNavGroup[];
    light_mode: boolean;
}

@Component({
    selector: 'app-cms-layout',
    imports: [NavigationComponent, MatIconModule, NavScrollDirective, ScrollToTableComponent, CmsComponent, NgStyle],
    templateUrl: './cms-layout.component.html',
    styleUrl: './cms-layout.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        '[class]': 'baseClass',
    },
})
export class CmsLayoutComponent {
    readonly baseClass: string = 'app-layout';
    layoutService = inject(LayoutService);

    layout = input<IAppLayoutConfig>();
    menuButtonRef = viewChild<ElementRef<HTMLButtonElement>>('menuButton');

    navLogo: ISbAsset[] = [];

    private _lastNavOpen = this.layoutService.navOpen();

    constructor() {
        effect(() => {
            const navOpen = this.layoutService.navOpen();
            if (!navOpen && this._lastNavOpen !== navOpen) {
                setTimeout(() => {
                    this.menuButtonRef()?.nativeElement?.focus();
                });
            }
            this._lastNavOpen = navOpen;
        });
    }

    openMenu() {
        this.layoutService.openNav();
    }
}
